import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { Helpers } from "../helpers";
import { IUserPortalFeatures } from "../models";
import { PortalService } from "./portal.service";

@Injectable({ providedIn: 'root' })
export class AuthorizationService {
  

  constructor(private portalService: PortalService) {
  }

  isPortalAllowed(sponsorName: string, portalName: string): boolean {
    let allPortals:Array<any> = Object.assign([], this.portalService.allUserPortals.value);
    for (var i = 0; i < allPortals.length; i++) {
      if (allPortals[i].SponsorName.toLowerCase() == sponsorName.toLowerCase()) {
        if (allPortals[i].Portals != null) {
          for (var j = 0; j < allPortals[i].Portals.length; j++) {
            if (allPortals[i].Portals[j].PortalName.toLowerCase() == portalName.toLowerCase()) {
              return true;
            }
          }
        }
        else if (allPortals[i].PortalName.toLowerCase() == portalName.toLowerCase() && !allPortals[i].isClinical)
          return true;
      }
    }
    return false;
  }
  isNavigationOrFeatueAllowed(featureName: string): boolean {
    //console.log('AuthorizationService', this.portalService.allUserPortalFeatures.value)
    let lstFeature = _.filter(this.portalService.allUserPortalFeatures.value, (item: IUserPortalFeatures) => { return item.FeatureName.toLowerCase() == featureName.toLowerCase() });
    if (lstFeature.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  getFeatueByFeatureId(featureId: number): IUserPortalFeatures[] {
    //console.log('AuthorizationService', this.portalService.allUserPortalFeatures.value)
    let lstFeature = _.filter(this.portalService.allUserPortalFeatures.value, (item: IUserPortalFeatures) => { return item.FeatureID == featureId });
    return lstFeature;
  }
}
